import { InputCheckbox, Stack, Text } from "@bookingcom/bui-react";
import { useI18n, t } from "@bookingcom/lingojs-react";
import { FilterCount } from "@flights/search-ui";
import useUserAgent from "hooks/useUserAgent";
import React, { useRef } from "react";
import useSearchFiltersController from "../useSearchFiltersController";
import flights_apex_web_filter_on_flexible_ticket from "utils/experiments/apex/flights_apex_web_filter_on_flexible_ticket";
import useIsInViewport from "hooks/useIsInViewport";
import { useAppliedFilters } from "hooks/search/useAppliedFilters";
import { useGetAvailableFilters } from "components/elements/SearchResults/components/boundsFilterHooks";
import styles from "./FlexibilityFilter.module.css";

const FlexibilityFilter = () => {
  const i18n = useI18n();
  const { isMobile } = useUserAgent();
  const { flexibility } = useSearchFiltersController();
  const visibilityRef = useRef<HTMLDivElement>(null);
  const isInViewport = useIsInViewport(visibilityRef);
  const appliedFilters = useAppliedFilters();
  const { filteredTotalCount } = useGetAvailableFilters();

  if (!flexibility.flexibleTicket.count) return null;

  const isFlexibleTicketChecked = !!flexibility.flexibleTicket.checked;

  if (isInViewport)
    flights_apex_web_filter_on_flexible_ticket.trackStages(
      isMobile,
      isFlexibleTicketChecked,
      appliedFilters.length,
      filteredTotalCount
    );

  const trackingPlaceholder = <div ref={visibilityRef} className={styles.trackingPlaceholder} />;

  if (!flights_apex_web_filter_on_flexible_ticket.trackWithDefaultStage()) return trackingPlaceholder;

  return (
    <>
      {trackingPlaceholder}
      <Stack gap={isMobile ? 4 : 2} attributes={{ "data-testid": "flexible-ticket-filter" }}>
        <Text variant="emphasized_1">{i18n.trans(t("flights_filters_flexibility_title"))}</Text>
        <FilterCount count={flexibility.flexibleTicket.count}>
          <InputCheckbox
            checked={isFlexibleTicketChecked}
            onChange={({ checked }) => {
              if (checked) {
                flights_apex_web_filter_on_flexible_ticket.goals.enable_flex();
                flights_apex_web_filter_on_flexible_ticket.goalsWithValue.enable_flex_filter_count(1);
              } else {
                flights_apex_web_filter_on_flexible_ticket.goals.disable_flex();
              }
              flexibility.set(checked, "flexibleTicket");
            }}
            label={
              <>
                <Text>{i18n.trans(t("flights_filters_flexibility_flex_ticket"))}</Text>
                <Text color="neutral_alt">{i18n.trans(t("flights_filters_flexibility_flex_ticket_sub"))}</Text>
              </>
            }
            name="flexibleTicket"
          />
        </FilterCount>
      </Stack>
    </>
  );
};

export default FlexibilityFilter;
